import type { QueryClient } from "@tanstack/react-query";
import { memberSessionStore } from "../../app/runtime";

export async function clearPasswordChangedSession(client: QueryClient, expectedSession = memberSessionStore.get()) {
  const replacedSession = () => memberSessionStore.get() !== null && memberSessionStore.get() !== expectedSession;
  if (replacedSession()) return false;
  await client.cancelQueries({ queryKey: ["member"] });
  if (replacedSession()) return false;
  client.removeQueries({ queryKey: ["member"] });
  memberSessionStore.clear();
  return true;
}
